import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';

@Component({
  selector: 'un-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagComponent {
  @Input() mode: 'default' | 'closeable' = 'default';
  @Output() closeClicked = new EventEmitter<void>();
  closed = false;
  constructor(private renderer: Renderer2, private el: ElementRef) {}
  close() {
    this.closed = true;
    this.closeClicked.emit();
    this.renderer.removeChild(
      this.renderer.parentNode(this.el.nativeElement),
      this.el.nativeElement
    );
  }
}
